"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoLimitGambleFeatureWinView = void 0;
const ImgLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/ImgLoader");
const GambleAssetConfig_1 = require("../config/GambleAssetConfig");
const FontStatics_1 = require("@nolimitcity/slot-launcher/bin/loader/font/FontStatics");
const PointerStateColorSet_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet");
const PointerStateIconSet_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateIconSet");
const Icon_1 = require("@nolimitcity/slot-launcher/bin/gui/displayobjects/Icon");
const IconToggleButton_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/IconToggleButton");
const gsap_1 = require("gsap");
const TimelineSprite_1 = require("@nolimitcity/slot-launcher/bin/animation/TimelineSprite");
const NoLimitGamblePlugin_1 = require("../NoLimitGamblePlugin");
const NolimitApplication_1 = require("@nolimitcity/slot-launcher/bin/NolimitApplication");
const GambleEvents_1 = require("../config/GambleEvents");
const GSAPCompatabilityWrapper_1 = require("@nolimitcity/slot-launcher/bin/utils/GSAPCompatabilityWrapper");
class NoLimitGambleFeatureWinView extends PIXI.Container {
    /**
     * @constructs
     * @param spinButtonClickCb
     */
    constructor(spinButtonClickCb) {
        super();
        this._centerX = 360;
        this._centerY = 360;
        this._isGambleSuccess = false;
        this._spinButtonCallback = spinButtonClickCb;
        this.init();
    }
    static set pieColor(value) {
        this._pieColor = value;
    }
    /**
     * @description To create different image items that are used in the creation of the wheel.
     * @param name
     */
    static createImageItem(name) {
        const item = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(name));
        item.anchor.set(0.5);
        return item;
    }
    /**
     * @description To create the pointer animation used in the wheel.
     */
    static createAnimation(length, posY, assetName) {
        let textures = [], name, animationItem;
        for (let i = 0; i < length; i++) {
            name = assetName + i;
            textures.push(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig[`${name}`]));
        }
        animationItem = new TimelineSprite_1.TimelineSprite(textures);
        animationItem.anchor.set(0.5);
        animationItem.position.set(0, posY);
        return animationItem;
    }
    /**
     * @description To disable the buttons.
     */
    disableButtons() {
        this._spinButton.enable(false);
    }
    /**
     * @description To show the view ans set up the required items to their init state.
     */
    show(featureWinPercentage) {
        const startPosOffsetWheel = [120, 0];
        this._isGambleSuccess = false;
        this._featureWinPercentage = featureWinPercentage;
        this.updateWheelMask(featureWinPercentage);
        this._spinButton.enable(true);
        this._spinButton.alpha = 1;
        this._spinButtonToggle.alpha = 1;
        this._spinText.alpha = 1;
        this._wheelGlow.alpha = 0;
        this._outerRingGlow.alpha = 0;
        this._featureImage.rotation = 0;
        this._wheel.rotation = 0;
        this._wheelGlow.rotation = 0;
        this._wheelContainer.position.set(this._centerX + startPosOffsetWheel[0], this._centerY + startPosOffsetWheel[1]);
        this._wheelContainer.scale.set(0.5);
        this._pointerAnimation.setFrame(0);
        this.visible = true;
        this._toggleTl.restart();
    }
    /**
     * @description When the response is received after the spin button was pressed.
     */
    onResponseReceived(isSuccess) {
        const tl = new gsap_1.TimelineLite();
        const delayToCompleteSpinning = 4;
        GSAPCompatabilityWrapper_1.GSAPCompatabilityWrapper.delayedCall(delayToCompleteSpinning, () => {
            this._isGambleSuccess = isSuccess;
            this._wheelSpinTween.pause();
            this._wheelSpinTween.kill();
            gsap_1.TweenLite.to([this._wheel, this._wheelGlow], (0.5 / 6.28) * (6.28 - this._wheel.rotation), {
                rotation: 6.28, ease: gsap_1.Linear.easeNone, onComplete: () => {
                    this.playWheelSpinningEnding();
                }
            });
            GSAPCompatabilityWrapper_1.GSAPCompatabilityWrapper.delayedCall(delayToCompleteSpinning, () => {
                this._pointerAnimation.stopLoop();
                this._wheelSpinTween.pause();
                this._wheelSpinTween.kill();
                this._featureImageTl.pause();
                this._featureImageTl.kill();
            });
        });
        //TODO - Fix so that the whole presentation is included in the timeline that is returned. So the controller knows when it's actually complete so it can continue at the right moment.
        tl.to(this, 10, {});
        return tl;
    }
    /**
     * @description When the entire gamble module is going to be dismissed.
     */
    allDone() {
        this.hide();
    }
    /**
     * @description When the spin button is clicked.
     */
    onSpinButtonClicked() {
        const duration = 0.5; // this duration is the time in which the wheel will scale to 1 and come to the center and the spinning has to start.
        this.killTimeline();
        this.disableButtons();
        gsap_1.TweenLite.to(this._spinButton.scale, 2 / 30, {
            x: 0.9,
            y: 0.9,
            onComplete: () => {
                gsap_1.TweenLite.to(this._spinButton.scale, 4 / 30, {
                    x: 1,
                    y: 1
                });
            }
        });
        gsap_1.TweenLite.to(this._spinButtonToggle.scale, 2 / 30, {
            x: 0.9,
            y: 0.9,
            onComplete: () => {
                gsap_1.TweenLite.to(this._spinButtonToggle.scale, 4 / 30, {
                    x: 1,
                    y: 1
                });
            }
        });
        gsap_1.TweenLite.to(this._spinButton, duration, { alpha: 0 });
        gsap_1.TweenLite.to(this._spinButtonToggle, duration, { alpha: 0 });
        gsap_1.TweenLite.to(this._spinText, duration, { alpha: 0 });
        gsap_1.TweenLite.to(this._wheelContainer.scale, duration, { x: 1, y: 1 });
        gsap_1.TweenLite.to(this._wheelContainer, duration, { x: this._centerX, y: this._centerY });
        GSAPCompatabilityWrapper_1.GSAPCompatabilityWrapper.delayedCall(duration, () => {
            const soundConfig = {
                name: NoLimitGamblePlugin_1.NoLimitGamblePlugin.SPIN_WHEEL_SOUND,
                loop: false
            };
            NolimitApplication_1.NolimitApplication.events.trigger(GambleEvents_1.GambleEvents.GAMBLE_PLAY_EFFECT_SOUND, soundConfig);
            this._pointerAnimation.playLoop();
            gsap_1.TweenLite.to(this._wheelGlow, 0.03, {
                alpha: 1, onComplete: () => {
                    gsap_1.TweenLite.to(this._wheelGlow, 1, { alpha: 0 });
                }
            });
            gsap_1.TweenLite.to(this._outerRingGlow, 0.03, {
                alpha: 1, onComplete: () => {
                    gsap_1.TweenLite.to(this._outerRingGlow, 1, { alpha: 0 });
                }
            });
            const initAngle = (Math.random() * (-0.5 - (-0.3)) + (-0.3));
            gsap_1.TweenLite.to([this._wheel, this._wheelGlow], 1, {
                rotation: initAngle, ease: gsap_1.Linear.easeNone, onComplete: () => {
                    gsap_1.TweenLite.to([this._wheel, this._wheelGlow], (0.5 / 6.28) * (-initAngle), {
                        rotation: 0, ease: gsap_1.Linear.easeNone, onComplete: () => {
                            this._wheelSpinTween = gsap_1.TweenMax.to([this._wheel, this._wheelGlow], 0.5, {
                                rotation: 6.28, ease: gsap_1.Linear.easeNone, repeat: -1
                            });
                        }
                    });
                }
            });
            this.playFeatureImageRotateTimeline();
        });
    }
    /**
     * @description To play the spinning of the wheel after the response is received.
     */
    playWheelSpinningEnding() {
        let stopAngle;
        if (this._isGambleSuccess) {
            this._featureWinPercentage -= 0.05;
            // when success we want the rotation angle to land on the positive side,
            // so using the positive half of the featureWinPercentage which means min value is 0 when calculating the random number.
            stopAngle = (Math.random() * (this._featureWinPercentage / 2));
        }
        else {
            // when failed the rotation angle should ignore the red masked part,
            // so subtracted featureWinPercentage from full rotation and used the positive side only.
            stopAngle = (Math.random() * (6.1 - this._featureWinPercentage) + (this._featureWinPercentage / 2));
            stopAngle += 0.1;
        }
        this._wheel.rotation = 0;
        this._wheelGlow.rotation = 0;
        gsap_1.TweenLite.to([this._wheel, this._wheelGlow], 1, {
            rotation: 6.28, ease: gsap_1.Linear.easeNone, onComplete: () => {
                this._wheel.rotation = 0;
                this._wheelGlow.rotation = 0;
                gsap_1.TweenLite.to([this._wheel, this._wheelGlow], 3, {
                    rotation: stopAngle, ease: gsap_1.Power4.easeOut, onComplete: () => {
                        if (this._isGambleSuccess) {
                            this._winWheelGlow.rotation = stopAngle;
                            this._winOuterRingGlow.rotation = stopAngle;
                            this._winWheelGlow.show();
                            this._winOuterRingGlow.show();
                            this._winWheelGlow.getAnimation();
                            this._winOuterRingGlow.getAnimation();
                            this.getWinAnimation();
                        }
                        else {
                            this.getLoseAnimation();
                        }
                        const soundConfig = {
                            name: NoLimitGamblePlugin_1.NoLimitGamblePlugin.SPIN_WHEEL_SOUND,
                            loop: false,
                            fadeOutDuration: 200
                        };
                        NolimitApplication_1.NolimitApplication.events.trigger(GambleEvents_1.GambleEvents.GAMBLE_STOP_EFFECT_SOUND, soundConfig);
                    }
                });
            }
        });
    }
    /**
     * @description To hide the view and dismiss everything.
     */
    hide() {
        this.visible = false;
        this._winWheelGlow.hide();
        this._winOuterRingGlow.hide();
        this._winWheelGlow.rotation = 0;
        this._winOuterRingGlow.rotation = 0;
        this._pointerAnimation.stopLoop();
        this.killTimeline();
    }
    /**
     * @description To kill the toggle timeline.
     */
    killTimeline() {
        this._toggleTl.pause();
        this._toggleTl.kill();
    }
    /**
     * @description To play the featureImage rotation during spinning of the wheel.
     */
    playFeatureImageRotateTimeline() {
        const tl = new gsap_1.TimelineLite({
            onComplete: () => {
                this.playFeatureImageRotateTimeline();
            }
        }), rotation = 0.1, duration = 0.5;
        tl.add(gsap_1.TweenLite.to(this._featureImage, duration, { rotation: -rotation }));
        tl.add(gsap_1.TweenLite.to(this._featureImage, duration, { rotation: rotation }));
        this._featureImageTl = tl;
    }
    /**
     * @description To update the red mask on the wheel.
     * @param featureWinPercentage
     */
    updateWheelMask(featureWinPercentage) {
        const radiansPerSector = featureWinPercentage, 
        // -(6.28 / 4) is used to move the mask part to the pointer tip.
        startingAngle = -(6.28 / 4) - (radiansPerSector / 2), endingAngle = startingAngle + radiansPerSector;
        this._wheelRedItem.clear();
        this._wheelRedItem.beginFill(NoLimitGambleFeatureWinView._pieColor, 1);
        this._wheelRedItem.moveTo(0, 0);
        this._wheelRedItem.arc(0, 0, this._wheel.width / 2, startingAngle, endingAngle);
        this._wheelRedItem.lineTo(0, 0);
        this._wheelRedItem.endFill();
        this._startingAngle = startingAngle;
        this._endingAngle = endingAngle;
    }
    /**
     * @description To initialize the view.
     */
    init() {
        this.createTextImageItem(GambleAssetConfig_1.GambleAssetConfig.WHEEL_OF_BONUS_TEXT, [360, 140], false);
        this.createDescriptionText();
        this.createSpinButton();
        this.createSpinButtonHighlightTimeline();
        this.createTextImageItem(GambleAssetConfig_1.GambleAssetConfig.SPIN_TEXT, [110, 560], true);
        this.createWheelAssets();
        this.createWinText();
        this.visible = false;
    }
    /**
     * @description To create the "WHEEL OF BONUS" text image and "SPIN" text image.
     */
    createTextImageItem(name, pos, isSpinText) {
        const item = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(name));
        item.anchor.set(0.5);
        item.position.set(pos[0], pos[1]);
        if (isSpinText) {
            item.blendMode = PIXI.BLEND_MODES.ADD;
            this._spinText = item;
        }
        this.addChild(item);
    }
    /**
     * @description To create the description text.
     */
    createDescriptionText() {
        const textStyle = new PIXI.TextStyle({
            fill: "#C5C5C5",
            fontFamily: "Open Sans",
            fontSize: 16,
            fontStyle: FontStatics_1.FontStyle.NORMAL,
            wordWrap: true,
            wordWrapWidth: 230,
            breakWords: true
        }), xPos = 115, yPos = 260, item = new PIXI.Text(NoLimitGamblePlugin_1.NoLimitGamblePlugin.apiPlugIn.translations.translate(NoLimitGambleFeatureWinView.DESCRIPTION_TEXT) + "\n" + NoLimitGamblePlugin_1.NoLimitGamblePlugin.apiPlugIn.translations.translate(NoLimitGambleFeatureWinView.DESCRIPTION_TEXT_P2), textStyle);
        item.anchor.set(0.5);
        item.position.set(xPos, yPos);
        this.addChild(item);
    }
    /**
     * @description To create the spin button.
     */
    createSpinButton() {
        const colors = new PointerStateColorSet_1.PointerStateColorSet(0xffffffff), onIcons = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.SPIN_WHEEL_WHITE_BUTTON))), btn = new IconToggleButton_1.IconToggleButton(NoLimitGambleFeatureWinView.SPIN_BUTTON, onIcons, colors), btnOffsetX = 248, btnOffsetY = 100;
        btn.addClickCallback(() => this._spinButtonCallback());
        btn.toggled = false;
        btn.pivot.set(btn.width / 2, btn.height / 2);
        btn.position.set(this._centerX - btnOffsetX, this._centerY + btnOffsetY);
        this._spinButton = btn;
        this.addChild(this._spinButton);
    }
    /**
     * @description To create the spin button's highlight animation between white and red.
     */
    createSpinButtonHighlightTimeline() {
        const spinBtnToggle = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.SPIN_WHEEL_RED_BUTTON)), toggleTl = new gsap_1.TimelineLite({
            paused: true,
            onComplete: () => { this._toggleTl.restart(); }
        }), duration = 0.5;
        spinBtnToggle.position.set(this._spinButton.x - this._spinButton.width / 2, this._spinButton.y - this._spinButton.height / 2);
        toggleTl.add(gsap_1.TweenLite.to(spinBtnToggle, duration, { alpha: 0 }));
        toggleTl.add(gsap_1.TweenLite.to(spinBtnToggle, duration, { alpha: 1 }));
        this._toggleTl = toggleTl;
        this._spinButtonToggle = spinBtnToggle;
        this.addChild(spinBtnToggle);
    }
    /**
     * @description To create the entire wheel.
     * P.S: - No item is positioned, only the wheel container is positioned whenever required, using the whole container as the whole wheel has to move to center and scale.
     */
    createWheelAssets() {
        const container = new PIXI.Container();
        container.pivot.set(container.width / 2, container.height / 2);
        this._wheel = NoLimitGambleFeatureWinView.createImageItem(GambleAssetConfig_1.GambleAssetConfig.WHEEL);
        this._wheelGlow = NoLimitGambleFeatureWinView.createImageItem(GambleAssetConfig_1.GambleAssetConfig.WHEEL_GLOW);
        this._winWheelGlow = NoLimitGambleFeatureWinView.createAnimation(7, 0, "WIN_WHEEL_GLOW_");
        this._outerRing = NoLimitGambleFeatureWinView.createImageItem(GambleAssetConfig_1.GambleAssetConfig.OUTER_RING);
        this._outerRingGlow = NoLimitGambleFeatureWinView.createImageItem(GambleAssetConfig_1.GambleAssetConfig.OUTER_RING_GLOW);
        this._winOuterRingGlow = NoLimitGambleFeatureWinView.createAnimation(8, 0, "WIN_OUTER_RING_GLOW_");
        this._featureImage = NoLimitGambleFeatureWinView.createImageItem(GambleAssetConfig_1.GambleAssetConfig.FEATURE_IMAGE);
        this._pointerAnimation = NoLimitGambleFeatureWinView.createAnimation(18, -240, "POINTER_");
        this._outerRingGlow.blendMode = PIXI.BLEND_MODES.ADD;
        this._winWheelGlow.hide();
        this._winWheelGlow.blendMode = PIXI.BLEND_MODES.ADD;
        this._winOuterRingGlow.hide();
        this._winOuterRingGlow.blendMode = PIXI.BLEND_MODES.ADD;
        this._wheelRedItem = new PIXI.Graphics();
        this._wheel.addChild(this._wheelRedItem);
        container.addChild(this._wheel, this._wheelGlow, this._winWheelGlow, this._outerRing, this._outerRingGlow, this._winOuterRingGlow, this._featureImage, this._pointerAnimation);
        this._wheelContainer = container;
        this.addChild(container);
    }
    /**
     * @description To create the win text.
     */
    createWinText() {
        this._winText = new PIXI.Text("WIN", NoLimitGamblePlugin_1.NoLimitGamblePlugin.winLoseTextStyle);
        this._winText.anchor.set(0.5, 0.5);
        this._winText.position.set(360, 230);
    }
    /**
     * @description To get the win text animation.
     */
    getWinAnimation() {
        const tl = new gsap_1.TimelineLite();
        tl.add([
            this.getTextAnimation(NoLimitGamblePlugin_1.NoLimitGamblePlugin.apiPlugIn.translations.translate(NoLimitGamblePlugin_1.NoLimitGamblePlugin.WIN_TEXT).toUpperCase()),
            () => {
                const soundConfig = {
                    name: NoLimitGamblePlugin_1.NoLimitGamblePlugin.WIN_WHEEL_SOUND,
                    loop: false
                };
                NolimitApplication_1.NolimitApplication.events.trigger(GambleEvents_1.GambleEvents.GAMBLE_PLAY_EFFECT_SOUND, soundConfig);
            }
        ]);
        return tl;
    }
    /**
     * @description To get the lose text animation.
     */
    getLoseAnimation() {
        const tl = new gsap_1.TimelineLite();
        tl.add([
            this.getTextAnimation(NoLimitGamblePlugin_1.NoLimitGamblePlugin.apiPlugIn.translations.translate(NoLimitGamblePlugin_1.NoLimitGamblePlugin.LOSE_TEXT).toUpperCase()),
            () => {
                const soundConfig = {
                    name: NoLimitGamblePlugin_1.NoLimitGamblePlugin.LOSE_CARD_SOUND,
                    loop: false
                };
                NolimitApplication_1.NolimitApplication.events.trigger(GambleEvents_1.GambleEvents.GAMBLE_PLAY_EFFECT_SOUND, soundConfig);
            }
        ]);
        return tl;
    }
    /**
     * @description To get the text animation.
     * @param text
     */
    getTextAnimation(text) {
        const tl = new gsap_1.TimelineLite();
        tl.add(() => {
            this._winText.text = text;
            this._winText.scale.set(0, 0);
            this.addChild(this._winText);
        });
        tl.to(this._winText.scale, 0.1, { x: 1, y: 1 });
        tl.to(this._winText.scale, 0.1, { x: 0, y: 0 }, "+=1");
        tl.add(() => {
            this.removeChild(this._winText);
        });
        return tl;
    }
}
exports.NoLimitGambleFeatureWinView = NoLimitGambleFeatureWinView;
NoLimitGambleFeatureWinView.DESCRIPTION_TEXT = "Gamble your winnings and win the bonus round.";
NoLimitGambleFeatureWinView.DESCRIPTION_TEXT_P2 = "The larger the winnings, the bigger chance to win.";
NoLimitGambleFeatureWinView.SPIN_BUTTON = "spinButton";
//# sourceMappingURL=NoLimitGambleFeatureWinView.js.map